import { Typography } from '@mui/material';
import { ScheduleTreatment } from '../../../../entities/ScheduleTreatment';
import {
  Event,
  DateRow,
  Header,
  HeaderEvent,
  HeaderTime,
  Period,
  Table,
  EventDescription,
  EventIcon,
  EmptyState
} from './styled';
import ScheduleTreatmentTableViewModel from './viewModel';

type ScheduleTreatmentTableProps = {
  scheduleTreatment: ScheduleTreatment | null;
};
export default function ScheduleTreatmentTable({ scheduleTreatment }: ScheduleTreatmentTableProps) {
  const { currentScheduleTreatment, getPeriod, getTypeIcon, hasTreatments } = ScheduleTreatmentTableViewModel({
    scheduleTreatment
  });

  if (!hasTreatments) {
    return (
      <EmptyState>
        <Typography variant="body2R">Não há eventos programados para esta data.</Typography>
      </EmptyState>
    );
  }

  return (
    <Table>
      <Header>
        <HeaderTime>
          <Typography variant="body2B">Horário</Typography>
        </HeaderTime>
        <HeaderEvent>
          <Typography variant="body2B">Evento</Typography>
        </HeaderEvent>
      </Header>

      {currentScheduleTreatment?.treatments.map((treatment, index) => (
        <DateRow key={index}>
          <Period>{getPeriod(treatment.period)}</Period>
          <Event>
            <EventDescription>{treatment.description}</EventDescription>
            <EventIcon>{getTypeIcon(treatment.treatmentType)}</EventIcon>
          </Event>
        </DateRow>
      ))}
    </Table>
  );
}
